import React, { useState } from "react";
import CodeTelephoneFinalisation from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneFinalisation/CodeTelephoneFinalisation";
import { VerificationTelephone } from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneSend/useValidationSchemaTelephone";
import CodeTelephoneSendContainer from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneSend/CodeTelephoneSendContainer";
import CodeTelephoneCheckContainer from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneCheck/CodeTelephoneCheckContainer";

export type VerificationTelephoneFormProps = {
  initialValues: VerificationTelephone;
  pageSuivante: (data: any) => void;
};


const VerificationTelephoneForm = ({ initialValues, pageSuivante }: VerificationTelephoneFormProps) => {

  const [currentStep, setCurrentStep] = useState(0);

  const handleStepSuivante = () => {
    setCurrentStep(currentStep + 1);
  }

  const handleStepPrecedente = () => {
    setCurrentStep(currentStep - 1);
  }


  return (
    <>
      {currentStep === 0 && <CodeTelephoneSendContainer initialValues={initialValues} stepSuivante={handleStepSuivante} pageSuivante={pageSuivante} /> }
      {currentStep === 1 && <CodeTelephoneCheckContainer initialValues={{...initialValues, code: ""}} stepSuivante={handleStepSuivante} stepPrecedente={handleStepPrecedente} pageSuivante={pageSuivante}/> }
      {currentStep === 2 && <CodeTelephoneFinalisation pageSuivante={pageSuivante} /> }
    </>

  );

};

export default VerificationTelephoneForm;